// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"121":"a3b29a56","299":"34930253","388":"da9e0970","605":"5b8cb22b","737":"34930253"}[chunkId] + ".chunk.css";
};